import React from 'react';
export function CheatSheet() {
  return <div className="max-w-5xl mx-auto w-full bg-white p-10 rounded-3xl border-2 border-red-200 shadow-2xl" data-id="element-168">
      <div className="flex items-center justify-between mb-8 border-b border-gray-100 pb-4" data-id="element-169">
        <h1 className="text-3xl font-bold text-red-600" data-id="element-170">
          Presenter Cheat Sheet
        </h1>
        <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm font-bold" data-id="element-171">
          HIDDEN PAGE
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-172">
        <div className="space-y-8" data-id="element-173">
          <section data-id="element-174">
            <h2 className="text-lg font-bold text-gray-800 mb-3 uppercase tracking-wider text-sm" data-id="element-175">
              2-Min Architecture Track
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-176">
              "Sierra sits between your channels and your systems of record.
              It's not just a chatbot; it's an orchestration engine. When a
              request comes in, it passes through our Identity layer to verify
              the user. Then, the Reasoning Engine determines intent and the
              next best action. Crucially, before it takes any action via your
              APIs-like Salesforce or ServiceNow-it must pass through our
              Guardrails and Supervisor model. If it hits a high-risk threshold
              or fails a policy check, it cleanly hands off to a human agent
              with full context."
            </p>
          </section>

          <section data-id="element-177">
            <h2 className="text-lg font-bold text-gray-800 mb-3 uppercase tracking-wider text-sm" data-id="element-178">
              3 "If Interrupted" Phrases
            </h2>
            <ul className="space-y-2 text-sm text-gray-700 bg-green-50 p-4 rounded-lg border border-green-100" data-id="element-179">
              <li className="font-medium" data-id="element-180">
                "Great question - quick answer is [X], and we can dive deeper in
                Q&A."
              </li>
              <li className="font-medium" data-id="element-181">
                "Let me park that and come back to it at the end of this
                section."
              </li>
              <li className="font-medium" data-id="element-182">
                "If it's alright, I'll finish this flow so you see the outcome,
                and then we'll dive in."
              </li>
            </ul>
          </section>
        </div>

        <div className="space-y-8" data-id="element-183">
          <section data-id="element-184">
            <h2 className="text-lg font-bold text-gray-800 mb-3 uppercase tracking-wider text-sm" data-id="element-185">
              Tools + Guardrails List
            </h2>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 space-y-4" data-id="element-186">
              <div data-id="element-187">
                <strong className="text-xs text-gray-500 uppercase" data-id="element-188">
                  Tools
                </strong>
                <ul className="text-sm text-gray-700 list-disc pl-4 mt-1" data-id="element-189">
                  <li data-id="element-190">verify_customer_otp</li>
                  <li data-id="element-191">lookup_account (Salesforce)</li>
                  <li data-id="element-192">fetch_device_entitlement</li>
                  <li data-id="element-193">issue_esim</li>
                  <li data-id="element-194">activate_esim</li>
                  <li data-id="element-195">create_case (ServiceNow)</li>
                </ul>
              </div>
              <div data-id="element-196">
                <strong className="text-xs text-gray-500 uppercase" data-id="element-197">
                  Guardrails
                </strong>
                <ul className="text-sm text-gray-700 list-disc pl-4 mt-1" data-id="element-198">
                  <li data-id="element-199">PII Redaction (always on)</li>
                  <li data-id="element-200">Auth Required (OTP gate)</li>
                  <li data-id="element-201">Confirmation Gate (explicit consent)</li>
                </ul>
              </div>
            </div>
          </section>

          <section data-id="element-202">
            <h2 className="text-lg font-bold text-gray-800 mb-3 uppercase tracking-wider text-sm" data-id="element-203">
              30-Second Close
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed bg-emerald-50 p-4 rounded-lg border border-emerald-100" data-id="element-204">
              "I'm here because I turn complex enterprise problems into clear,
              safe technical motions. With ACME, we don't need a massive
              transformation-we need to start with high-friction journeys like
              eSIM, prove the containment and CSAT, and expand safely. I'm ready
              to run that playbook."
            </p>
          </section>
        </div>
      </div>
    </div>;
}